<template>
  <div class="bg-light vh-100">
    <div class="row p-0 m-0">
      <div class="col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
        <div class="card shadow-sm mt-3">
          <div class="card-body text-center">
            <img
              alt=""
              src="../../public/images/logo.png"
              width="80"
              class="my-4"
            />
            <div>
              <h2 class="text-dark text-bold">
                <i class="fa-regular fa-message text-info"></i> BeNeat Chat
              </h2>
            </div>
            <div class="mt-4 w-100">
              <div class="col-12">
                <b-button
                  variant="outline-dark"
                  block
                  @click.prevent="loginByGoogle"
                >
                  <img
                    src="../../public/images/google_logo.png"
                    width="25"
                    class="img-fluid"
                    alt="google"
                  />
                  <span style="margin-left: 5px">Sign in with Google</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { auth } from '@/helpers/firebaseHelpers'
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth'

export default {
  name: 'Login',
  data () {
    return {
      section: 'Login',
      email: '',
      password: ''
    }
  },
  computed: {
    ...mapState({
      error: state => state.admin.error,
      loading: state => state.admin.loading,
      redirectUrl: state => state.general.redirectUrl
    }),
    isLoggingIn () {
      return this.loading ? 'Loading...' : 'Login'
    }
  },
  methods: {
    ...mapActions('aiAssistant', ['fetchAdminIds']),
    async login (email = null) {
      if (!email) {
        return
      }
      try {
        const params = {
          email
        }
        let admin = await this.$store.dispatch(
          'admin/LOGIN_WITH_FIREBASE',
          params
        )
        if (admin && admin.id) {
          const paramsPermission = {
            admin_id: admin.id,
            permissions: ['/stealth-mode-reading-chat']
          }
          await this.$store.dispatch('admin/fetchPermissions', paramsPermission)
          // Check AI Assistant Admin Ids
          await this.fetchAdminIds()
        }

        const redirect = localStorage.getItem('redirect')
        if (redirect) {
          localStorage.removeItem('redirect')
          this.$router.push(redirect)
        } else if (this.redirectUrl) {
          this.$router.push(this.redirectUrl)
        } else {
          this.$router.push(`/conversations`)
        }
      } catch (err) {
        this.$swal({
          icon: 'error',
          text: err.message
        })
      }
    },
    async loginByGoogle () {
      const provider = new GoogleAuthProvider()
      provider.addScope('profile')
      signInWithPopup(auth, provider)
        .then(async result => {
          // request real firebase id token for auth with firebaseAdmin
          const credential = GoogleAuthProvider.credentialFromResult(result)
          if (credential) {
            // console.log('check credential', credential)
            const user = result.user
            if (user) {
              this.login(user.email)
            }
          }
        })
        .catch(error => {
          console.log('error login', error.message)
        })
    }
  },
  mounted () {
    // console.log('check auth user', auth.currentUser)
  }
}
</script>

<style scoped lang="scss">
a.login-password {
  display: inline-block;
  margin: 0px auto;
  margin-bottom: 15px;
}

.container-table {
  display: table;
  color: #66615b;
}

.vertical-10p {
  padding-top: 10%;
}

.logo {
  width: 10em;
  padding: 2em;
}

.loginForm .input-group {
  padding-bottom: 1em;
  height: 4em;
}

.input-group input {
  height: 4em;
}
</style>
